import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Only preconnect to origins used in the critical path (max 2 for best performance)
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnectCDN);
const preconnectGstatic = document.createElement('link');
preconnectGstatic.rel = 'preconnect';
preconnectGstatic.href = 'https://fonts.gstatic.com';
preconnectGstatic.crossOrigin = 'anonymous';
document.head.appendChild(preconnectGstatic);
// Load Google Fonts NON-BLOCKING with minimal weights
// Inter: 400,500,600,700 (removed 300 — use font-normal instead of font-light)
// Merriweather: 700,900 + italic 400 only (covers all heading/serif usage)
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Merriweather:ital,wght@0,700;0,900;1,400&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
render(<App data-id="element-3" />, document.getElementById('root'));